export const handleDiceDrawIgnoreZonesInput = (
  camerasObject: any,
  setCamerasObject: any,
  checked: boolean
) => {
  // Update localStorage first so AutoAddTable doesn't overwrite our changes
  const diceAlertPostObject = JSON.parse(
    localStorage.diceAlertPostObject || "{}"
  );
  diceAlertPostObject.draw_ignore_zones = checked;
  localStorage.setItem(
    "diceAlertPostObject",
    JSON.stringify(diceAlertPostObject)
  );

  // Create a deep copy of the camerasObject to ensure React detects the change
  const newCamerasObject = { ...camerasObject };

  for (const key in camerasObject) {
    newCamerasObject[key] = {
      ...camerasObject[key],
      dice: {
        ...camerasObject[key].dice,
      },
    };
    newCamerasObject[key].dice.draw_ignore_zones = checked;
  }

  setCamerasObject(newCamerasObject);
};
